import { increment, off, onValue, ref, update } from "firebase/database";
import { db } from "../lib/firebase";
import types from "../types";
import { getPathDatabaseByRole } from "./auth";
import { LaunchError } from "../utils/errors";
import { HOME_FEATURE_IDS } from "../data/homeFeatures";

const setHomeFeatureActivity = (features) => ({
  type: types.SET_HOME_FEATURE_ACTIVITY,
  payload: features,
});

export const startListenerHomeFeatureActivity =
  ({ onReferenceAvailable = () => {} } = {}) =>
  async (dispatch) => {
    try {
      const { pathHomeFeatureActivity } = dispatch(getPathDatabaseByRole());

      if (!pathHomeFeatureActivity) {
        dispatch(setHomeFeatureActivity({}));
        return false;
      }

      const dbRef = ref(db, `${pathHomeFeatureActivity}/features`);

      onValue(dbRef, (snapshot) => {
        dispatch(setHomeFeatureActivity(snapshot.val() || {}));
      });

      onReferenceAvailable(dbRef);
      return true;
    } catch (error) {
      dispatch(
        LaunchError(error, false, [], {
          functionName: "startListenerHomeFeatureActivity",
          context: {},
          tags: { action: "listenerHomeFeatureActivity" },
          level: "error",
        })
      );
      dispatch(setHomeFeatureActivity({}));
      return false;
    }
  };

export const stopListenerHomeFeatureActivity = ({ listenerRef } = {}) => {
  if (listenerRef) {
    off(listenerRef);
  }
};

export const startTrackHomeFeatureUsage =
  ({ featureID }) =>
  async (dispatch) => {
    try {
      if (!featureID || !HOME_FEATURE_IDS.includes(featureID)) {
        throw new Error("Invalid featureID for home feature activity tracking");
      }

      const { pathHomeFeatureActivity } = dispatch(getPathDatabaseByRole());

      if (!pathHomeFeatureActivity) {
        return false;
      }

      const featurePath = `${pathHomeFeatureActivity}/features/${featureID}`;

      await update(ref(db), {
        [`${featurePath}/count`]: increment(1),
        [`${featurePath}/lastUsedAt`]: Date.now(),
      });

      return true;
    } catch (error) {
      dispatch(
        LaunchError(error, false, [], {
          functionName: "startTrackHomeFeatureUsage",
          context: { featureID },
          tags: { action: "trackHomeFeatureUsage" },
          level: "error",
        })
      );
      return false;
    }
  };
